/*
 * Ryan O'Dowd
 * 2024-01-24
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React, {
  useMemo,
} from 'react';
import {
  Card, // @TODO: create wrapper for this in common
} from 'react-native-paper';
import Icon from '@react-native-vector-icons/material-design-icons';
import {
  Link,
} from 'react-router';
import Text from '@components/common/Text';
import Tooltip from '@components/common/Tooltip'; // @TODO: doesn't work if scrolled...
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';
import utilities from '@utils/utilities';

const GoalPreview = (props: GoalPreviewProps) => { // @TODO: abstract this with MyCampaigns/CampaignPreview
  const styles = hooks.useStyles(getStyles);

  const statusIcon = useMemo(() => {
    if (props.goal?.classroom_goal_metadata?.status === 'draft') { // @TODO: shouldn't have to null check classroom_goal_metadata
      return <Icon name='alert' style={[styles.icon, styles.draftIcon]} />;
    }

    return <Icon name='check-decagram' style={[styles.icon, styles.publishedIcon]} />;
  }, [props.goal?.classroom_goal_metadata?.status, styles]); // @TODO: shouldn't have to null check classroom_goal_metadata

  if (!props.goal?.classroom_goal_metadata) {
    return 'Loading...'; // @TODO: better loading
  }

  return (
    // @TODO: there should be a visual indication of active/inactive campaigns...maybe a button to toggle visibility too
    <Link
      style={styles.container}
      to={`/schools/${props.schoolId}/classrooms/${props.classroomId}/goals/${props.goal.id}`}
    >
      <Card>{/* @TODO: should have rounded corners even with no cover or actions */}
        <Card.Content style={[styles.cardContent, {backgroundColor: props.goal.classroom_goal_metadata.status === 'draft' ? styles.colors.primary : styles.colors.primaryExtraDark}]}>{/* @TODO: to styles.ts */}
          <View style={styles.nameAndStatus}>
            <Text style={styles.goalName}>{props.goal.title}</Text>
            <Tooltip title={props.goal.classroom_goal_metadata.status}>{statusIcon}</Tooltip>
          </View>
          <Text style={styles.goalDates}>{utilities.prettyAvailablityDateRange(props.goal.date_available, props.goal.date_deadline)}</Text>
          {/* @TODO: student progress...e.g. 4/12 students complete? */}
          {/* @TODO:
          <p>{props.description}</p>
          */}
          <View style={styles.goalMetadataWrapper}>
            <Text style={styles.goalMetadata}># modules: {props.goal.modules.length}</Text>
            <Text style={styles.goalMetadata}># assignments: {props.goal.modules.reduce((total, module) => total + module.assignments.length, 0)}</Text>
            <Text style={styles.goalMetadata}># students: {props.goal.classroom_goal_metadata.student_count}</Text>
          </View>
        </Card.Content>
      </Card>
    </Link>
  );
};

class GoalPreviewProps {
  // @TODO: add proptypes
  classroomId: number;
  schoolId: number;
  // @TODO: start_datetime: string; // @TODO: date object?
  // @TODO: end_datetime: string; // @TODO: date object?
  // @TODO: is_active: boolean, // @TODO: not used yet...maybe can be inferred by start and end date though instead of passed in explicitly
  goal: any;
};

export default GoalPreview;
